import * as React from 'react';
import { SVGProps } from 'react';
const TriangleDialog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={18}
    fill="none"
    viewBox="0 0 15 18"
    {...props}
  >
    <path fill="#fff" d="m0 0 14.606 10.287-11.748 7.348L0 0Z" />
  </svg>
);
export default TriangleDialog;
